/* pLength = Total Length. cLength = Length of thing to center */
export default (function findCenter(pLength, cLength) {
  return (pLength - cLength) / 2;
});